import React from "react";
import PropTypes from "prop-types";
import { translate } from "@td/shared_utils";
import TaskDate from "./TaskDate";
import styles from "./styles.module.scss";
import { statusCodes } from "../../constants";

const TaskDatesSubtitle = React.memo(({ task }) => {
  const isCompleted = task.status === statusCodes.COMPLETED;
  const dynamicSubtitleLabel = isCompleted ? "completed" : "updated";
  const dynamicSubtitleDate = isCompleted ? task.statusChangeDt : task.updatedAt;

  return (
    <div className={styles.taskDates}>
      <TaskDate label={translate(null, "care_team_tasks.edit_task_modal", "created")} date={task.createdAt} />
      <TaskDate label={translate(null, "care_team_tasks.edit_task_modal", dynamicSubtitleLabel)} date={dynamicSubtitleDate} />
    </div>
  )
});

TaskDatesSubtitle.propType = {
  task: PropTypes.shape({
    status: PropTypes.string.isRequired,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    statusChangeDt: PropTypes.string,
  })
};

TaskDatesSubtitle.displayName = "TaskDatesSubtitle";
export default TaskDatesSubtitle;
